import config from "../config";
import { ListActionProvider } from "@beeldit/core/actions/list/ListActionContext";
import { RemoveActionProvider } from "@beeldit/core/actions/remove/RemoveActionContext";
import { CreateActionProvider } from "@beeldit/core/actions/create/CreateActionContext";
import { DetailsActionProvider } from "@beeldit/core/actions/details/DetailsActionContext";
import TableWithDetailsPage from "@beeldit/core/pages/TableWithDetailsPage";
import TablePage from "@beeldit/core/pages/TablePage";
import { EditActionProvider } from "@beeldit/core/actions/edit/EditActionContext";
import { useParams } from "react-router-dom";

function TreatmentSessionTypesPage() {  

  let { treatmentId } = useParams();

  if (!treatmentId) {
    treatmentId = "0";
  }

  const tablePageParams = {
    modelConfig: config, // Configuración del modelo
    formDefaultValues: {treatment_id: parseInt(treatmentId)}, // Valores por defecto del formulario
    filters: {treatment_id: parseInt(treatmentId)}, // Valores por defecto del formulario
  }

  return (
    <ListActionProvider key={config.modelName}>
      <RemoveActionProvider>
        <CreateActionProvider>
          <EditActionProvider>
            <TablePage
              {...tablePageParams}
            />
          </EditActionProvider>
        </CreateActionProvider>
      </RemoveActionProvider>
    </ListActionProvider>
  );
}

export default TreatmentSessionTypesPage;
